import './styles.css';

const About = () => {

    return (
        <div className="about">
            <p className="about-content">
                I am a full stack developer with a passion for building web applications. I have a strong background in
                front-end development and have worked with a wide range of technologies. This app essentially either just
                plots a graph based on user input or uses random value.

            </p>
        </div>
    )
}

export default About;